import { render, staticRenderFns } from "./BankStatement.vue?vue&type=template&id=5a700c54"
import script from "./BankStatement.vue?vue&type=script&lang=js"
export * from "./BankStatement.vue?vue&type=script&lang=js"
import style0 from "./BankStatement.vue?vue&type=style&index=0&id=5a700c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports